"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledDeleteDialogContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const action_dialog_styles_1 = require("../../../../../generic/action-dialog/action-dialog.styles");
exports.StyledDeleteDialogContent = (0, styled_components_1.default)(action_dialog_styles_1.StyledActionDialogContent) `
  && .MuiAlert-outlined {
    box-shadow: none;
    color: ${({ theme }) => theme.palette.accent.main};
  }

  & .button--error.Mui-disabled {
    color: ${({ theme }) => theme.palette.action.disabled};
    background-color: ${({ theme }) => theme.palette.action.disabledBackground};
  }
`;
